import { GetterTree } from "vuex";
import { IProvidersUsersState } from ".";
import { IRootState } from "@/store/types";
import { IProvidersUser } from "@/models/providers-user";

export const getters: GetterTree<IProvidersUsersState, IRootState> = {
    scopedUsersList(state): IProvidersUser[] | null {
        return state.usersScopedList;
    },
    scopedCPUsersList(state): IProvidersUser[] | null {
        return state.usersScopedCPList;
    },
    unscopedUsersList(state): IProvidersUser[] | null {
        return state.usersUnscopedList;
    },
    selectedProvidersUser(state): IProvidersUser | null {
        return state.selectedProvidersUser;
    },
    isSelectedProvidersUser(state): boolean {
        return state.isSelectedProvidersUser;
    },
};
